enum ImmunizationStatus {
    OverriddenToInvalid = "OI",
    ForecastInvalid = "FI",
    DoseInvalid = "DI",
    ForecastValid = "FV",
    OverriddenToValid = "OV"
}

export { ImmunizationStatus };
